import { render } from "./InvoiceIssuanceDetail.vue?vue&type=template&id=353bb17f&scoped=true"
import script from "./InvoiceIssuanceDetail.vue?vue&type=script&lang=js"
export * from "./InvoiceIssuanceDetail.vue?vue&type=script&lang=js"

import "./InvoiceIssuanceDetail.vue?vue&type=style&index=0&id=353bb17f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-353bb17f"]])

export default __exports__